
// CSS
import './styles/swalcontainer.css'
import './App.css'


import { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Base from "./layouts/Base";
import Home from "./pages/Home";
import About from "./pages/About";


import Blogs from "./pages/Blogs";
import BlogDetails from "./page_components/blog/BlogDetails";
import CreateBlog from "./page_components/blog/CreateBlog";


// CERTIFICATE
import CertificateList from "./page_components/certificate/certificate_list";

// ERROR 404
import NotFound from "./pages/NotFound";
import Certificates from "./pages/Certificates";
import CertificateDetails from "./page_components/certificate/certificate_details";
import CertificateAdd from "./page_components/certificate/crud/certificate_add";
import CertificateUpdate from "./page_components/certificate/crud/certificate_update";


// SOCIAL SERVICE
import SocialServiceParent from "./page_components/social_service/social_service_parent";
import SocialServices from "./pages/SocialServices";
import SocialServiceAdd from "./page_components/social_service/crud/social_service_add";
import SocialServiceUpdate from "./page_components/social_service/crud/social_service_update";

// USERS
import Users from './pages/Users';

// NOTARIAL BOOKS
	// TRANSACTIONS
import TransactionAdd from './page_components/notarial_book/crud_transaction/transaction_add';
import TransactionDetails from './page_components/notarial_book/crud_transaction/transaction_details';
import TransactionUpdate from './page_components/notarial_book/crud_transaction/transaction_update';
import TransactionDelete from './page_components/notarial_book/crud_transaction/transaction_delete';

	// LAWYERS




// import useFetchLocations from "./hooks/useFetchLocations";
import Login from './pages/Login';

import PrivateRoute from './utils/privateRouteUtils'

// import validateTokens from './services/TokenChecker';
import UserListTest from './page_components/user/user_list_test';
import VideoCall from './pages/VideoCall';
import Jurat from './pages/Jurat';
import TechOath from './pages/TechOath';
import TechOath_old from './pages/TechOath_old';

import VideoCallNew from './pages/VideoCallNew';


import { jwtDecode } from 'jwt-decode';
import RealTimeTransactions from './pages/RealTimeTransactions';
import NotificationSender from './pages/NotificationSender';
import TransactedDocuments from './pages/TransactedDocuments';

// AWS RealTime
import RealTimeTransactionsAWS from './pages/RealTimeTransactionsAWS';
import TechOathAmplify from './pages/TechOathAmplify';
import VideoCallNewWindow from './pages/VideoCallNewWindow';

// CONTEXT
import {AuthProvider, useAuth} from './contexts/AuthContext'


// COMPONENTS
import SendSMS from './pages/SendSMS';
import SendEmail from './pages/SendEmail';


import TechOathAmplifyAdd from './page_components/notary/crud/techoathamplify_add';
import TechOathAmplifyAddWizard from './page_components/notary/crud/techoathamplify_add_wizard';
import DrawingPage from './pages/Drawing';
import CameraSwitcher from './pages/CameraSwitcher';
import CameraComponent from './pages/CameraZoom';
import Signature from './pages/Signature';

import PermissionPrompt from './components/PermissionPrompt';
import SMSManager from './pages/SMSManager';

import Maps from './components/Maps';



// NOTARIAL BOOKS
import NotarialBook from './pages/NotarialBook';
import LawyerAdd from './page_components/notarial_book/crud_lawyer/lawyer_add';



// TEST PAGES
import TestMap from './pages/TestMap';
import CameraBlurParent from './pages/CameraBlurParent';
import TestWordToPrint from './pages/TestWordToPrint';
import TestDraggableElements from './pages/TestDraggableElements';
import TestImagestoPDF from './pages/TestImagesToPDF';


// USER PINGER STATUS - IS ONLINE OR OFFLINE
import { startUserPinger, stopUserPinger } from './utils/userPinger';
// AMPLIFY
import { generateClient } from 'aws-amplify/api';
import * as subscriptions from './graphql/subscriptions';
import { createUserStatus, updateUserStatus } from './graphql/mutations';
import { listUserStatuses } from './graphql/queries';

import useModelData from './hooks/useModelData';
import TabTransactions from './page_components/notarial_book/tab_transactions';
import TabLawyers from './page_components/notarial_book/tab_lawyers';
import TabSettings from './page_components/notarial_book/tab_settings';
import PageAccountInfo from './page_components/notarial_book/tab_settings/page_account_info';
import PageNotarialInfo from './page_components/notarial_book/tab_settings/page_notarial_info';
import PageSecurity from './page_components/notarial_book/tab_settings/page_security';
import VerifyEmailPage from './page_components/notarial_book/tab_settings/pages_security/VerifyEmailPage';
import OTPVerify from './pages/OTPVerify';
import TestVideocall from './pages/TestVideocall';
import TestPreCallSetup from './pages/TestPreCallSetup';
import TestFinalVideoCall from './pages/TestFinalVideoCall';
import VideoCallNewWindowTest from './pages/VideoCallNewWindowTest';
import Register from './pages/Register';
import TestPrintPreviewMobile from './pages/TestPrintPreviewMobile';
import TestPrint from './pages/TestPrint';
import AiAnalytics from './pages/AiAnalytics';
import TestMapping from './pages/TestMapping';
import TestMappingLeaflet from './pages/TestMappingLeaflet';
import PSAGeoportal from './pages/TestMappingLeaflet2';
import TestMapping3 from './pages/TestMappingLeaflet3';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import TestReusableParent from './pages/TestReusableParent';
import QRChecker from './pages/QRChecker';
 

function App() {


	const { isLoggedIn, isLoading, user, login, logout,hasCameraPermission, hasLocationPermission } = useAuth(); // Get auth context values
	const [hasPermission, setHasPermission] = useState(false)


	const { updateItem, checkItemExists } = useModelData({
		model: "UserStatus",
		queries: {
			update: updateUserStatus,
			list: null,
		},
		subscriptions: {
		},
	});
	useEffect(() => {
		if (!isLoggedIn || !user || !user.user_id) return;

		const startHeartbeat = async () => {
			const filter = { user_profile_id: { eq: user.user_id } };

			try {
				const existingStatus = await checkItemExists(listUserStatuses, filter);
				if (!existingStatus) {
					console.warn('No user status record found for heartbeat');
					return;
				}
				const id = existingStatus.id;
				//console.log('[Heartbeat] Status ID:', id);

				startUserPinger({
					id,
					updateItem, // passed from useModelData
				});
			} catch (error) {
				//console.error('[Heartbeat] Error checking user status:', error);
			}
		};

		setTimeout(() => {
			startHeartbeat();
		}, 30000);



		return () => {
			stopUserPinger(); // cleanup
		};
	}, [isLoggedIn, user?.user_id]); // only runs once user.user_id is defined





	// REMOVING CACHE NOTARIAL BOOKS
	useEffect(() => {
	const CACHE_KEYS = [
		'notarialbook_cache_map_transaction',
		'notarialbook_cache_map_lawyer',
	];
	const CACHE_TTL = 5 * 60 * 1000; // 5 minutes
	const now = Date.now();

	CACHE_KEYS.forEach((CACHE_KEY) => {
		const rawCache = localStorage.getItem(CACHE_KEY);
		if (rawCache) {
		const cacheMap = JSON.parse(rawCache);

		for (const key in cacheMap) {
			if (now - cacheMap[key].timestamp > CACHE_TTL) {
			delete cacheMap[key];
			}
		}

		localStorage.setItem(CACHE_KEY, JSON.stringify(cacheMap));
		}
	});
	}, []);





	// useEffect(() => {
	//   //console.log(process.env.REACT_APP_API_URL);
	//   console.log(isLoggedIn);
	// }, [isLoggedIn]);



	// FETCH LOCATION

	//const data = useFetchLocations(`${process.env.REACT_APP_API_URL}/locations/`);
 
	//   const [username, setUsername] = useState('');
	//   const [password, setPassword] = useState('');
  
	//   const handleLogin = async () => {
	// 	  try {
	// 		  const response = await fetch('http://localhost:8000/api/login/', {
	// 			  method: 'POST',
	// 			  headers: {
	// 				  'Content-Type': 'application/json'
	// 			  },
	// 			  body: JSON.stringify({ "user_profile_id":username })
	// 		  });
	// 		  // Handle response as needed (e.g., set authentication state)
	// 	  } catch (error) {
	// 		  console.error('Error logging in:', error);
	// 	  }
	//   };




 
	return (
		// <>
		// 	<VideoCall />
		 //	<UserListTest />
		// </>
		
 
		<HelmetProvider>
			<Router basename="/iusevolutione">
				<Routes>


				{/* OUTSIDE PAGES : LANDING PAGE */}
				<Route path="/smsmanager" element={<SMSManager />} />


				<Route path="/verify-otp" element={<OTPVerify />} />


				<Route path="/register" element={<Register />} />


				<Route path="/verify-email" element={<VerifyEmailPage />} />


				<Route path="/forgot-password" element={<ForgotPassword />} />


				<Route path="/change-password/:id" element={<ChangePassword />} />


				<Route path="/qr-checker/:id/" element={<QRChecker />} />

			 


 


				{!isLoading && !isLoggedIn && (
					<Route path="/login" element={<Login login={login} />} />

				)}

				{/* Redirect to home if already logged in */}
				{!isLoading && isLoggedIn && (
					<Route path="/login" element={<Navigate to="/oath" />} />
				)}

								



					<Route element={<PrivateRoute isLoggedIn={isLoggedIn} isLoading={isLoading} />}>
						<Route path="/" element={<Base />}>

 
							{/* Conditionally show PermissionPrompt if permissions are not granted */}
							<Route path="" index
								element={
									!isLoggedIn ? (
										<Navigate to="/login" /> // Redirect to login if not logged in
									) : hasCameraPermission && hasLocationPermission ? (
										<Home />
									) : (
										<PermissionPrompt />
									)
								}
							/>

							<Route
								path="/login"
								element={!isLoggedIn ? <Login /> : <Navigate to="/" />}
							/>


							{/* <Route  path=""  index element={<Home />} /> */}

						 
														
							
							<Route  path="index"  index element={<Home />} />
							<Route path="about" element={<About />} />

							{/* BLOGS */}
							<Route path="blogs" element={<Blogs />} />
							<Route path="blogs/:id" element={<BlogDetails />} />
							<Route path="blogs/create" element={<CreateBlog />} />

							{/* CERTIFICATES */}
							<Route path="certificates" element={<Certificates />} />
							<Route path="certificates/:id" element={<CertificateDetails />} />
							<Route path="certificates/add" element={<CertificateAdd />} />
							<Route path="certificates/update/:id" element={<CertificateUpdate />} />
							<Route path="certificates/delete/:id" element={<CertificateAdd />} />

							{/* SOCIAL SERVICES */}
							<Route path="ss" element={<SocialServices />} />
							<Route path="ss/:category" element={<SocialServiceParent />} />
							<Route path="ss/:category/add" element={<SocialServiceAdd />} />
							<Route path="ss/:category/update/:id" element={<SocialServiceUpdate />} />

							{/* USERS */}
							<Route path="users" element={<Users />} />

							{/* JURAT */}
							{/* <Route path="jurat" element={<Jurat />} /> */}

							{/* TECHOATH */}
							{/* <Route path="oath" element={<TechOath userId={userId} />} /> */}
							<Route path="oath" element={<TechOathAmplify />} />



							<Route path="oath/add" element={<TechOathAmplifyAdd />} />
							<Route path="oath/addwizard" element={<TechOathAmplifyAddWizard />} />

							
							<Route path="oath/update/:id" element={<TechOathAmplify />} />




							{/* TECHOATH  OLD */}
							<Route path="ooath" element={<TechOath_old />} />

							{/* rt */}
							{/* <Route path="rt" element={<RealTimeTransactions />} /> */}

							<Route path="realtimeaws" element={<RealTimeTransactionsAWS />} />



							{/* TECHOATH  OLD */}
							<Route path="vc" element={<VideoCallNew />} />


							{/* NOTARIAL BOOKS PARENT WILL REMAIN AND IT WILL ACT AS A WRAPPER */}
							{/* <Route path="notarialbook" element={<NotarialBook />}>
								<Route path="transactions" element={<NotarialBookTransactions />} />
								<Route path="users" element={<NotarialBook />} />
							</Route> */}


							<Route path="notarialbook" element={<NotarialBook />} >

								<Route index element={<Navigate to="transactions?page=1" replace />}  /> {/*  THIS IS THE DEFAULT PAGE WHEN GOING TO /notarial without anything after like /notarial/transacitons  */}
								<Route path = "transactions" element = {<TabTransactions />} />{/*  TO NAVIGATE TO THE DEFAULT PAGE  */}



								<Route path = "transaction/add" element        = {<TransactionAdd />} />
								<Route path = "transaction/:id" element        = {<TransactionDetails />} />
								<Route path = "transaction/update/:id" element = {<TransactionUpdate />} />
								<Route path = "transaction/delete/:id" element = {<TransactionDelete />} />

 
								<Route path = "lawyers" element = {<TabLawyers />} />

								<Route path = "settings" element = {<TabSettings />}>
									<Route index element={<Navigate to="userdetails" replace />}  />
									<Route path = "userdetails" element = {<PageAccountInfo />} />
									<Route path = "notarydetails" element = {<PageNotarialInfo />} />
									<Route path = "security" element = {<PageSecurity />} />
								</Route>

							</Route>

								<Route path = "notarialbook/lawyer/add" element = {<LawyerAdd />} />








							<Route path="notification" element={<NotificationSender />} />


							{/* TRANSACTED DOCS */}
							<Route path="documents" element={<TransactedDocuments />} />


							{/* SEND SMS */}
							<Route path="send_sms" element={<SendSMS />} />


							{/* SEND SMS */}
							<Route path="send_email" element={<SendEmail />} />


							<Route path="draw" element={<DrawingPage />} />
							<Route path="cameraswitcher" element={<CameraSwitcher />} />
							<Route path="camerazoom" element={<CameraComponent />} />
							<Route path="signature" element={<Signature />} />


							{/* MAPS */}
							<Route path="map" element={<Maps />} />


							{/* TEST PAGES */}
							<Route path="test/camera" element={<CameraBlurParent  />} />
							{/* <Route path="test/word" element={<TestWordToPrint  />} /> */}
							<Route path="test/draggable" element={<TestDraggableElements  />} />
							<Route path="test/imgtopdf" element={<TestImagestoPDF  />} />


							<Route path="test/videocall" element={<TestVideocall  />} />
							<Route path="test/videocall2" element={<TestPreCallSetup  />} />
							<Route path="test/videocall3" element={<TestFinalVideoCall  />} />





							


							<Route path="test/print" element={<TestPrint  />} />


							<Route path="test/reusable" element={<TestReusableParent  />} />


 



							{/* 404 */}
							<Route path="*" element={<NotFound />} />
						</Route>

						
						{/* VIDEO CALL */}
						<Route path="vc/:mid/:id/:apitransactionid" element={<VideoCallNewWindow />} />

						<Route path="vctest/:mid/:id/:apitransactionid" element={<VideoCallNewWindowTest />} />

						<Route path="vcp/:mid/:id/:apitransactionid" element={<VideoCallNewWindowTest />} />



						<Route path="/verify-email" element={<VerifyEmailPage />} />


						{/* GEMINI */}
						<Route path="/analytics" element={<AiAnalytics />} />

						{/* MAPS */}
						<Route path="/testmap" element={<TestMapping />} />
						<Route path="/testmap2" element={<TestMappingLeaflet />} />
						<Route path="/testmap3" element={<PSAGeoportal />} />
						<Route path="/testmap4" element={<TestMapping3 />} />










					</Route>
				</Routes>
			</Router>
		</HelmetProvider>
	);
}

const AppWithAuth = () => {
	return (
	  <AuthProvider>
		<App />
	  </AuthProvider>
	);
  };
  
  export default AppWithAuth;